import { TextField } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Form } from '../type';

const useStyles = makeStyles((theme: Theme) => ({
  input: {
    margin: theme.spacing(),
  },
}));

function DefaultInput<T>({ store, editable, type }: Form<T>) {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    store.setValue(e.target.value as any);
  };

  return (
    <TextField
      label={t(store.label)}
      disabled={!editable}
      value={store.value}
      onChange={handleChange}
      className={classes.input}
      variant="outlined"
      type={type}
    />
  );
}

export default observer(DefaultInput);
